import theme from 'kb-shared/theme';
import { TimeSlotBubble } from 'screens/Book/components/BookingCalendarTime/components/DaySection.styled';
import styled from 'styled-components';

export const AppointmentTypeFilterButton = styled(TimeSlotBubble)<{
  disabled?: boolean;
  selected?: boolean;
}>`
  position: relative;

  ${({ selected }) =>
    selected &&
    `
      box-shadow: 0 0 8px 0 ${theme.colors.neutral.primaryNavy}, 0 0 24px 0 rgba(0, 0, 0, 0.2);
      background-color: white;
    `}

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const ClosedMarketPrompt = styled.p`
  margin: 24px 0 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  margin: 32px 0;
  align-items: center;
`;
